import React from 'react'
import { Card, CardHeader, CardTitle } from 'reactstrap'

export default function Lock() {
  return (
    <div className='content'><Card><CardHeader><CardTitle tag="h4">Lock</CardTitle></CardHeader></Card> </div>
  )
}
